import { render, staticRenderFns } from "./DocumentValidity.vue?vue&type=template&id=22b58130"
import script from "./DocumentValidity.vue?vue&type=script&lang=ts"
export * from "./DocumentValidity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports